const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.95 43.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "power_w") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.45,8.75A18.16,18.16,0,0,0,1.2,27.08C2.48,35.44,10,42,19.11,42.17A18.05,18.05,0,0,0,36,30.75c2.93-8-.75-17.6-9-22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.97,
    y1: 1,
    x2: 18.97,
    y2: 18.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerW);
export default __webpack_public_path__ + "static/media/power_w.bb0cf46c8903933529780e1292a14695.svg";
export { ForwardRef as ReactComponent };